import { useCallback, useEffect, useState } from 'react';
import { gtmEvents } from '../../../utils/gtm';
import { useMsId } from '../../../store/appStore';
import { buildRedirectUrl, getUpgradeCompleteGTMConfig } from '../utils';

interface UseUpgradeCompleteReturn {
  isRedirecting: boolean;
  execute: () => Promise<void>;
}

export const useUpgradeComplete = (): UseUpgradeCompleteReturn => {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const metaSiteId = useMsId();

  const execute = useCallback(async () => {
    try {
      const gtmConfig = getUpgradeCompleteGTMConfig(metaSiteId);
      gtmEvents.premiumUpgradeComplete(gtmConfig);
      setIsRedirecting(true);
      // Small delay to ensure GTM event is sent
      await new Promise((resolve) => setTimeout(resolve, 2000));
      window.location.href = buildRedirectUrl(metaSiteId);
    } catch (error) {
      // Fallback redirect on error
      window.location.href = buildRedirectUrl();
    }
  }, [metaSiteId]);

  // Auto-execute when component mounts
  useEffect(() => {
    execute();
  }, [execute]);

  return {
    isRedirecting,
    execute,
  };
};
